require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-enrico-sangiuliano-max-watts.json") })
        }
      }, "path---interview-enrico-sangiuliano-max-watts");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-enrico-sangiuliano-max-watts!./.cache/json/interview-enrico-sangiuliano-max-watts.json
// module id = 672
// module chunks = 231608221292675